import React, { useState } from 'react';
import {
  Badge, Box, HStack, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger,
  Portal, Spinner, Text,
} from '@chakra-ui/react';
import { useStripeSubDetail } from '../hooks/useRecurringRevenues';

// item 1128 (Chad) — the Stripe line detail as a HOVER wherever a subscription row shows
// (Recurring page grid + the project section share one grid). Lazy: nothing is fetched
// until the first hover; the server caches per sub for 5 minutes on top.
const StripeSubDetailHover: React.FC<{ recurringId: string; children: React.ReactNode }> = ({
  recurringId, children,
}) => {
  const [opened, setOpened] = useState(false);
  const { data, status } = useStripeSubDetail(recurringId, opened);

  return (
    <Popover trigger="hover" isLazy openDelay={350} placement="right" onOpen={() => setOpened(true)}>
      <PopoverTrigger>
        <Box cursor="help" minW={0}>{children}</Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="auto" maxW="360px" fontSize="xs">
          <PopoverArrow />
          <PopoverBody>
            {status === 'loading' && (
              <HStack>
                <Spinner size="xs" />
                <Text>Reading Stripe…</Text>
              </HStack>
            )}
            {status === 'error' && <Text color="red.400">Could not read Stripe.</Text>}
            {status === 'success' && data && !data.available && (
              <Text opacity={0.7}>{data.error ?? 'No live Stripe detail for this subscription.'}</Text>
            )}
            {status === 'success' && data?.available && (
              <Box>
                <HStack spacing={2} mb={1}>
                  {data.status && <Badge colorScheme={data.status === 'active' ? 'green' : 'gray'}>{data.status}</Badge>}
                  {data.autoPay && <Badge colorScheme="blue">auto-pay</Badge>}
                  {data.created && <Text opacity={0.6}>{`since ${String(data.created).slice(0, 10)}`}</Text>}
                </HStack>
                {/* item 1130 — the invoice MEMO leads: that's where the client/agreement
                    info lives on the legacy subs */}
                {data.memo && <Text fontWeight="bold" mb={1}>{data.memo}</Text>}
                {data.description && <Text>{data.description}</Text>}
                {(data.lines ?? []).map((l) => <Text key={l}>{l}</Text>)}
                {(data.customFields ?? []).map((f) => <Text key={f} opacity={0.8}>{f}</Text>)}
                {data.footer && <Text opacity={0.6} mt={1}>{data.footer}</Text>}
                {(data.lines ?? []).length === 0 && !data.description && !data.memo && (
                  <Text opacity={0.7}>No line detail on the Stripe subscription.</Text>
                )}
              </Box>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default StripeSubDetailHover;
